import { useShowFeature } from '@seek/ca-myprofile-utils';
import { useMelwaysInfo } from '@seek/melways-react';

import { useTypedSelector } from 'src/reducers';

import { isFeatureActive } from '.';

export const useIsPublicProfileEnabled = () => {
  const zone = useTypedSelector((store) => store.page.pageAnalytics.zone);
  const { language: melwaysLanguage } = useMelwaysInfo();

  const showFeature = useShowFeature(zone, melwaysLanguage);

  return showFeature('public-profile') || isFeatureActive('public-profile');
};
